import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';

import Table from '@mui/material/Table';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import Typography from '@mui/material/Typography';
import TableContainer from '@mui/material/TableContainer';

const cellSX = {
	pl: 0.5,
	pr: 0.5,
	'&:first-of-type': {
		zIndex: 1,
		position: 'sticky',
		left: 0,
		background: '#f9fafb',
	},
	'&:nth-of-type(2)': { pl: 3 },
};

const TableValuation = ({ cols = [], rows = [] }) => {
	const theme = useTheme();

	const cellDividerSX = {
		...cellSX,
		pr: 2,
		'& + th, & + td': {
			pl: 2,
			borderLeft: `1px solid ${theme.palette.divider}`,
		},
	};

	return (
		<TableContainer>
			<Table
				sx={{
					'& td, & th': {
						py: 0,
						borderBottom: 'unset',
						whiteSpace: 'nowrap',
						textTransform: 'unset',
					},
				}}
			>
				<TableHead sx={{ border: 'unset' }}>
					<TableRow>
						{cols.map(({ id, label, labels }, indexCol) => {
							const isDivider = indexCol > 0 && indexCol < cols.length - 1;

							return (
								<TableCell
									colSpan={labels.length}
									sx={isDivider ? cellDividerSX : cellSX}
									key={id}
								>
									{label}
								</TableCell>
							);
						})}
					</TableRow>

					<TableRow>
						{cols.map((col, indexCol) =>
							col.labels.map(({ id, label }, indexLabel) => {
								const isDivider =
									indexCol > 0 &&
									indexLabel === col.labels.length - 1 &&
									indexCol < cols.length - 1;

								return (
									<TableCell sx={isDivider ? cellDividerSX : cellSX} key={id}>
										<Typography color="secondary" sx={{ fontSize: 'inherit' }}>
											{label}
										</Typography>
									</TableCell>
								);
							}),
						)}
					</TableRow>
				</TableHead>

				<TableBody>
					{rows.map((row) => (
						<TableRow hover={false} tabIndex={-1} key={row.id}>
							{cols.map((col, indexCol) =>
								col.labels.map(({ id }, indexLabel) => {
									const isDivider =
										indexCol > 0 &&
										indexLabel === col.labels.length - 1 &&
										indexCol < cols.length - 1;

									return (
										<TableCell sx={isDivider ? cellDividerSX : cellSX} key={id}>
											{row[id]}
										</TableCell>
									);
								}),
							)}
						</TableRow>
					))}
				</TableBody>
			</Table>
		</TableContainer>
	);
};

TableValuation.propTypes = {
	cols: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
			label: PropTypes.string,
			labels: PropTypes.arrayOf(
				PropTypes.shape({
					id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
					label: PropTypes.string,
				}),
			),
		}),
	),
	rows: PropTypes.arrayOf(
		PropTypes.objectOf(
			PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
		),
	),
};

export default TableValuation;
